module.exports = __webpack_public_path__ + "img/售后服务ico.0ac1eb45.png";